import React from 'react';
import { Button, Modal, Form, notification } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { compose as recompose, withHandlers, withProps} from 'recompose';
import { Field, reduxForm } from 'redux-form';
import { required  } from '../../../helpers/validate';
import { FieldInput, FieldSelect } from '../../../components/Fields';


import { GROUP_FORM_KEY, GroupFormAction } from '../../../reduxs/menu-redux/action';

const MenuForm = (props) => {
  const { open, close, group, clients, reset, handleSubmit } = props;
  const submit = handleSubmit(GroupFormAction);

  let _clients = [];
  if(clients && clients.length) {
    _clients = clients.map((item) => {
      return {
        value: item.Id,
        text: item.Name
      }
    })
  }

  return (
    <Modal
      title={group ? 'Cập nhật nhóm menu' : 'Thêm nhóm menu' }
      visible={open}
      style={{ top: 20 }}
      width={'760px'}
      footer={null}
      maskClosable={false}
      onOk={() => { reset(); close(false) }}
      onCancel={() => { reset(); close(false) }}
      className="modal-form-menu"
    >
      <Form layout="vertical" onFinish={submit}>
        <div className="row">
          <div className="col-md-6">
            <Field
              component={FieldInput}
              label="Tên menu"
              name="Name"
              placeholder="Nhập tên menu"
              className="required"
              validate={[required]}
            />
          </div>
          <div className="col-md-6">
            <Field
              component={FieldSelect}
              label="Hệ thống"
              name="ClientId"
              placeholder=""
              options={_clients}
              className="required"
              validate={[required]}
            />
          </div>
        </div>
        <p>Ghi chú:&ensp;<span className="note-red">Trường không được để trống</span></p>
        <Form.Item className="text-center">
            <Button type="primary" icon={<SaveOutlined />} htmlType="submit">{group ? "Cập nhật" : "Lưu"}</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default recompose(
    withProps(({group, ClientId}) => {
        if(group) {
          return { initialValues: { ...group }};
        } else {
          return { initialValues:  { ClientId: ClientId }};
        }
      }
    ),
    withHandlers({
    }),
    reduxForm({
      form: GROUP_FORM_KEY,
      enableReinitialize: true,
      onSubmitSuccess: (result, dispatch, props) => {
          notification.success({
              message: 'Lưu thành công!'
          });
          props.initialValues = null;
          props.reset();
          props.close(false);
          props.fetchMenus();
          props.setTabs();
      }
    })
)(MenuForm);
